/**
 * Icon — render a lucide icon by the kebab-case name stored in the nav config
 * (the vanilla used a global lucide UMD scan; React uses explicit components).
 * Only the icons actually referenced by the nav are imported, so the bundle
 * stays lean (no full lucide tree).
 */
import {
  Circle,
  LayoutDashboard,
  LayoutPanelTop,
  Workflow,
  Network,
  Banknote,
  Users,
  ClipboardEdit,
  KanbanSquare,
  ClipboardCheck,
  Rocket,
  LineChart,
  Folder,
  BookOpen,
  Settings,
  Shield,
  UserCheck,
  Grid3x3,
  Briefcase,
  Award,
  Sparkles,
  Heart,
  Copy,
  Target,
  Gauge,
  Settings2,
  ListOrdered,
  Shuffle,
  CheckSquare,
  Eye,
  Flag,
  MessageCircle,
  AlertTriangle,
  Brain,
  Package,
  Calculator,
  Gift,
  List,
  PlusCircle,
  BadgeCheck,
  Calendar,
  Store,
  ClipboardList,
  BarChart3,
  Users2,
  FilePlus,
  Files,
  File,
  UserCog,
  ShieldCheck,
  Inbox,
  type LucideIcon,
} from 'lucide-react';

const MAP: Record<string, LucideIcon> = {
  'layout-dashboard': LayoutDashboard,
  'layout-panel-top': LayoutPanelTop,
  workflow: Workflow,
  network: Network,
  banknote: Banknote,
  users: Users,
  'clipboard-edit': ClipboardEdit,
  'kanban-square': KanbanSquare,
  'clipboard-check': ClipboardCheck,
  rocket: Rocket,
  'line-chart': LineChart,
  folder: Folder,
  'book-open': BookOpen,
  settings: Settings,
  shield: Shield,
  'user-check': UserCheck,
  'grid-3x3': Grid3x3,
  briefcase: Briefcase,
  award: Award,
  sparkles: Sparkles,
  heart: Heart,
  copy: Copy,
  target: Target,
  gauge: Gauge,
  'settings-2': Settings2,
  'list-ordered': ListOrdered,
  shuffle: Shuffle,
  'check-square': CheckSquare,
  eye: Eye,
  flag: Flag,
  'message-circle': MessageCircle,
  'alert-triangle': AlertTriangle,
  brain: Brain,
  package: Package,
  calculator: Calculator,
  gift: Gift,
  list: List,
  'plus-circle': PlusCircle,
  'badge-check': BadgeCheck,
  calendar: Calendar,
  store: Store,
  'clipboard-list': ClipboardList,
  'bar-chart-3': BarChart3,
  'users-2': Users2,
  'file-plus': FilePlus,
  files: Files,
  file: File,
  'user-cog': UserCog,
  'shield-check': ShieldCheck,
  inbox: Inbox,
};

export function Icon({ name, className }: { name: string; className?: string }) {
  const Cmp = MAP[name] ?? Circle;
  return <Cmp className={className} />;
}
